define(function (require) {

    var BaseTableWidgetsManager = require('web-agent-framework/BaseTableWidgetsManager');

    var MyConnectionsListWidgetsManager = BaseTableWidgetsManager.extend({
        ControllerName: 'MyConnectionsListWidgetsManager',
        applicationType: 'MyConnectionsListWidgetsManager'
    });

    return MyConnectionsListWidgetsManager;

});
